function getBaseUrl() {
  const url = process.env.REACT_APP_BASE_URL || "http://localhost:5000/api/administration/";
  // Strip trailing slash: several call sites build URLs as `${getBaseUrl()}/api/...`,
  // and a trailing slash here produces a double slash that 404s (axios's own
  // baseURL joining tolerates it, but manual window.open() concatenation doesn't).
  return url.replace(/\/+$/, "");
}

const APP_PORTS = {
  // Notification campaigns are served by the Admin Backend API (same :5000 host),
  // mounted at the root /notification path. Kept here so the rootAxios port
  // rewrite resolves to the right service.
  NOTIFICATION_PORT: "5000",
};

module.exports = { getBaseUrl, APP_PORTS };
